import { NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AngularFireModule }        from '@angular/fire';
import { AngularFirestoreModule }   from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule }    from '@angular/fire/auth';
import { AuthService } from './service/auth.service';
import { FormsModule } from '@angular/forms';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { HttpClientModule, HttpClient} from '@angular/common/http';
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts/ngx';
import { HTTP } from '@ionic-native/http/ngx';
import { SendMessagesModalPageModule } from './send-messages-modal/send-messages-modal.module';
import { CategoryFilterPageModule } from './//category-filter/category-filter.module';
import { IonicGestureConfig } from './gestures/ionic-gesture-config';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AddToCartPageModule } from './add-to-cart/add-to-cart.module';
import { AndroidPermissions} from '@ionic-native/android-permissions/ngx';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ImageSliderModelPageModule } from "./image-slider-model/image-slider-model.module";
import { NgxIonicImageViewerModule } from 'ngx-ionic-image-viewer';
import { FCM } from '@ionic-native/fcm/ngx';
import { UniqueDeviceID } from '@ionic-native/unique-device-id/ngx';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    TranslateModule.forRoot(),
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    LazyLoadImageModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule, 
    AngularFireStorageModule,
    SendMessagesModalPageModule,
    AngularFireMessagingModule,
    ImageSliderModelPageModule,
    //imagine modules here
    CategoryFilterPageModule,
    AddToCartPageModule,
    NgxIonicImageViewerModule,
    ServiceWorkerModule.register('combined-sw.js', { enabled: environment.production })
    //ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AuthService,
    Contacts,
    HTTP,
    FCM,
    UniqueDeviceID,
    AndroidPermissions,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HAMMER_GESTURE_CONFIG, useClass: IonicGestureConfig},

  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
